<template>
  <div class="home">
    <div class="title">
      Danghuan
    </div>
    <div class="mobile-upload">
      <div class="top-section">
        <div>
          <h5 class="margin0">IMEI</h5>
          <span class="text">拨号键盘输入*#06#可查看</span>
          <div class="upload">
            <div class="schematic-box">
              <span class="schematic-text">Schematic</span>  
              <img src="../../assets/image/upload/1.png" alt="" class="demo-img">
            </div>
            <van-uploader
              name="0"
              v-model="fileList"
              progress
              class="upload-box"
              :progress-interval="500"
              :after-read="afterRead"
              :before-delete="beforeDelete"
              :max-count="1"
            >
              <div class="upload-box">
                <img src="../../assets/image/upload/6.png" alt="" class="upload-icon">
                <span>点击拍照</span>
              </div> 
            </van-uploader>
          </div>
        </div>
        <div>
          <h5>后盖图</h5>
          <span class="text">或者其他严重破损的机身</span>
          <div class="upload">
            <div class="schematic-box">
              <span class="schematic-text">Schematic</span>  
              <img src="../../assets/image/upload/3.png" alt="" class="demo-img">
            </div>
            <div class="upload-box">
              <van-uploader
                v-model="fileList1"
                progress
                name="1"
                class="upload-box"
                :progress-interval="500"
                :after-read="afterRead"
                :before-delete="beforeDelete"
                :max-count="1"
              >
                <div class="upload-box">
                  <img src="../../assets/image/upload/6.png" alt="" class="upload-icon">
                  <span>点击拍照</span>
                </div> 
              </van-uploader>
            </div>
          </div>
        </div>
      </div>
      
      <div class="footer-btn">
        <van-button class="btn" @click="submit" :disabled="fileList.length === 0 || fileList1.length === 0">提交</van-button>
      </div>
    
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import customUpload from './../../components/common-upload/index.vue'
import { photoPolicyPutUpload,uploadDetectionAttachments } from '../../services/api/brandList.js'
export default {
  name: 'inspectionPhotograph',
  components: {
    customUpload
  },
  data () {
    return {
      fileList: [],
      fileList1: []
    }
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen
      }
    })
  },
  methods: {
    submit(){
      console.log(this.$route)
      const attachmentUrlList = this.fileList.concat(this.fileList1).map(item => item.url);
      uploadDetectionAttachments({
          goodsCode: this.$route.query.goodsCode,
          attachmentUrlList
        })
        .then((res) => {
        })
        .catch(() => {
        });
    },
    afterRead(files, detail) {
      console.log(files, detail)
      const { file } = files;
      const { name } = detail
      const formData = new FormData();
      formData.append("file", file);
      photoPolicyPutUpload(formData)
        .then((res) => {
          const { imageUrl } = res;
          if(name == 0){
            this.fileList = []
            this.fileList.push({
              url: imageUrl
            })
          }else if(name == 1){
            this.fileList1 = []
            this.fileList1.push({
              url: imageUrl
            })
          }
          console.log(this.fileList,this.fileList1)
        })
        .catch(() => {
        });
    },
    beforeDelete(files, detail){
      console.log(files, detail)
      const { name } = detail
      if(name == 0){
        this.fileList = []
      }else if(name == 1){
        this.fileList1 = []
      }
    }
  }
}
</script>
<style scoped lang="less">
@media (max-width: 980px) {

  .home{
    background: #F6F6F6;
  }

  .footer-btn{
    height: 140px;
    width: 100%;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 0;
    background-color: #fff;
    border: none;
    .btn{
      height: 100px;
      border-radius: 10px;
      border: none;
      width: 700px;
      background: var(---Brand-1, #FF9600);
      color: #fff;
      font-size: 32px;
    }
  }

  .title{
    height: 88px;
    background-color: #fff;
    line-height: 88px;
    text-align: center;
  }

  h5{
    text-align: left;
    color: #333;
    font-family: "PingFang SC";
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin: 40px 0 20px;
  }

  .margin0{
    margin-top: 0;
  }

  .text{
    text-align: left;
    display: inline-block;
    width: 100%;
    margin-bottom: 20px;
    font-size: 28px;
    color: #666;
  }

  .schematic-box{
    position: relative;
    .schematic-text{
      position: absolute;
      left: 0;
      top: 0;
      border-radius: 8px 0px 8px 0;
      opacity: 0.6;
      background: #333;
      color: #fff;
      font-size: 24px;
    }
  }

  .top-section{
    margin: 24px;
    padding: 24px;
    background-color: #fff;
    border-radius: 16px;
    overflow: hidden;
  }

  .demo-img,.upload-box{
    width: 320px;
    height: 320px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: #F7F7F7;
    border-radius: 16px;
    overflow: hidden;
    span{
      color: #999;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-top: 16px;
    }
    .upload-icon{
      width: 80px;
      height: 80px;
    }

    /deep/.van-uploader__preview-image{
      width: 100%;
      height: 100%;
    }
    /deep/.van-uploader__preview-delete{
      position: absolute;
      top: 10PX;
      right: 10px;
      width: 14px;
      height: 14px;
      background-color: rgba(0, 0, 0, .7);
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    /deep/.van-uploader__preview-delete-icon{
        position: absolute;
        top: -1px; 
        right: -1px; 
        color: #fff;
        font-size: 16px;
        -webkit-transform: scale(.5);
        transform: scale(.5);
    }
  }
  
  .upload{
    display: flex;
    justify-content: space-between;
  }

}
@media (min-width: 981px) {
  .home {
   
  }
}
</style>
